import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "390",
  height: "48",
  viewBox: "0 0 390 48",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M0 0V48.0009H390V2.24478e-06C344.18 28.517 273.853 46.7704 195 46.7704C116.147 46.7704 45.8203 28.517 0 0Z" }, null, -1)
  ])))
}
export default { render: render }